module.exports = __webpack_public_path__ + "img/center-right.f83c29c8.png";